<template>
  <div class="main-quotes">
    <swiper v-bind="swiperOptions" :modules="swiperModules">
      <swiper-slide v-for="quote in items" :key="quote.id" class="main-quotes__slide">
        <div class="main-quotes__image"></div>
        <div class="main-quotes__content">
          <p class="main-quotes__item--text">{{ quote.text }}</p>
          <p class="main-quotes__item--author">{{ quote.author }}</p>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script src="./quotes.js"></script>
<style src="./quotes.scss" lang="scss"></style>
